import React, { useEffect, useState } from "react";
import TabsComponent from "./TabsComponent";
import { Outlet, useParams } from "react-router-dom";
import UploadSelectionList from "./sections/UploadSelectionList";
import { useDispatch } from "react-redux";
import { fetchCandidateList } from "./candidateListFunctions";

export default function ProjectCandidateList() {
  const { projectId } = useParams();
  const dispatch = useDispatch();

  const navButtons = [
    {
      id: 1,
      name: "upload-selection-list",
      url: "",
    },
    {
      id: 2,
      name: "update-visa-details",
      url: "update-visa-details",
      checkAccessMain: "Project",
      checkAccessSub: "project-job-enquiry-list",
      // disabled: true,
    },
    {
      id: 3,
      name: "update-flight-details",
      url: "update-flight-details",
      checkAccessMain: "Project",
      // disabled: true,
    },
  ];
  const [currentSection, setCurrentSection] = useState("upload-selection-list");
  useEffect(() => {
    setCurrentSection(
      location.pathname.split("/").at(5) || "upload-selection-list"
    );
  }, [location.pathname]);

  const [candidateListData, setCandidateListData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCandidateList(projectId, setCandidateListData, setLoading, dispatch);
  }, []);

  // useEffect(() => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 500);
  // }, [candidateListData]);

  return (
    <div className="w-full">
      <TabsComponent
        currentSection={currentSection}
        setCurrentSection={setCurrentSection}
        navButtons={navButtons}
      />
      {currentSection == "upload-selection-list" ? (
        <UploadSelectionList
          candidateListData={candidateListData}
          setCandidateListData={setCandidateListData}
          loading={loading}
        />
      ) : (
        <Outlet
          context={{ candidateListData, setCandidateListData, loading }}
        />
      )}
    </div>
  );
}
